module.exports = __webpack_public_path__ + "static/media/america-tigres.5a401be2.jpg";